import Transform from '@ember-data/serializer/transform';

export default Transform.extend({
  /**
   * @inheritDoc
   */
  deserialize: function(serialized) {
    return JSON.parse(serialized) || undefined;
  },

  /**
   * @inheritDoc
   */
  serialize: function(deserialized) {
    throw new Error('not supported yet');
  }
});
